// Client-side helpers for Telegram lead notifications.
// The bot credentials live server-side (Express /api/notify/*) — never in the bundle.

export async function sendTelegramMessage(text) {
    try {
        await fetch('/api/notify/message', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ text }),
        });
    } catch (error) {
        console.error('Telegram notify failed:', error);
    }
}

export async function sendTelegramPhoto(file, caption) {
    try {
        const data = await fileToBase64(file);
        await fetch('/api/notify/photo', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ filename: file.name, data, caption }),
        });
    } catch (error) {
        console.error('Telegram photo failed:', error);
    }
}

function fileToBase64(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(String(reader.result).split(',')[1]);
        reader.onerror = reject;
        reader.readAsDataURL(file);
    });
}
